import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface ActivityItem {
  id: string;
  type: 'commission' | 'upgrade' | 'report' | 'other';
  title: string;
  description: string;
  color: string;
}

interface RecentActivityProps {
  activities?: ActivityItem[];
}

const RecentActivity = ({
  activities = [
    {
      id: '1',
      type: 'commission',
      title: 'New commission earned',
      description: 'John Smith - $45.50',
      color: 'bg-green-500',
    },
    {
      id: '2',
      type: 'upgrade',
      title: 'Client upgraded tier',
      description: 'Sarah Johnson → Silver',
      color: 'bg-blue-500',
    },
    {
      id: '3',
      type: 'report',
      title: 'Monthly report generated',
      description: '2 hours ago',
      color: 'bg-purple-500',
    },
  ],
}: RecentActivityProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {activities.map(activity => (
            <div key={activity.id} className="flex items-center gap-3">
              <div className={`w-2 h-2 ${activity.color} rounded-full`}></div>
              <div className="flex-1">
                <p className="text-sm font-medium">{activity.title}</p>
                <p className="text-xs text-gray-500">{activity.description}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
